import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import CommonImageSliderShowAs
  from 'components/dashboard/image-slider/common-slider/CommonImageSliderShowAs';
import CommonTabList from 'components/common/tabs/CommonTabList';
import CommonTabItem from 'components/common/tabs/CommonTabItem';
import ImageSliderDropzone
  from 'components/dashboard/image-slider/ImageSliderDropzone';
import CommonImageSliderDescriptionTabContent
  from 'components/dashboard/image-slider/common-slider/CommonImageSliderDescriptionTabContent';
import ImageSliderShapeSize
  from 'components/dashboard/image-slider/ImageSliderShapeSize';
import ImageSliderAppearance
  from 'components/dashboard/image-slider/ImageSliderAppearance';
import CommonLinkDeleteButton
  from 'components/common/link-elements/CommonLinkDeleteButton';

import './CommonImageSliderExpandedContent.css';


function CommonImageSliderExpandedContent(props) {
  const { item, deleteImageSlider, patchImageSlider } = props;
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('description');

  return (
    <div className="common-image-slider-expanded-content__component">
      {/* Main Wrapper */}
      <div className="main-block">
        <div className="images-block">
          <ImageSliderDropzone item={item} />
        </div>

        <div className="settings-block">
          <CommonImageSliderShowAs
            item={item}
            patchImageSlider={patchImageSlider}
          />

          <CommonTabList>
            <CommonTabItem
              active={activeTab === 'description'}
              tabName={t("Description & Link")}
              onClick={() => { setActiveTab('description'); }}
            />
            <CommonTabItem
              active={activeTab === 'advance'}
              tabName={t("Shape & Size")}
              onClick={() => { setActiveTab('advance'); }}
            />
            <CommonTabItem
              active={activeTab === 'appearance'}
              tabName={t("Appearance")}
              onClick={() => { setActiveTab('appearance'); }}
            />
          </CommonTabList>

          {activeTab === 'description' &&
            <CommonImageSliderDescriptionTabContent item={item} />
          }

          {activeTab === 'advance' &&
            <ImageSliderShapeSize item={item} />
          }

          {activeTab === 'appearance' &&
            <ImageSliderAppearance item={item} />
          }
        </div>

        <div className="delete-mobile">
          <CommonLinkDeleteButton
            key={`common-image-slider-delete-mobile-icon-key-${item.id}`}
            linkItem={item}
            deleteFunction={deleteImageSlider}
          />
        </div>
      </div>
    </div>
  );
};

CommonImageSliderExpandedContent.propTypes = {
  deleteImageSlider: PropTypes.func.isRequired,
  patchImageSlider: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
};

export default CommonImageSliderExpandedContent;
